import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { Field, FormikProps, useFormikContext } from 'formik'
import { CheckboxInput } from '../../../../../../../components/inputs/CheckboxInput'

interface Props {}

export const DemolitionTechnicalFormB1C: React.FC<Props> = () => {
  const formik = useFormikContext() as FormikProps<any>
  return (
    <FormSectionTwoColumns
      title="c) stručný popis stavebních objektů, inženýrských objektů a jejich konstrukcí"
      subtitle="a technických nebo technologických zařízení"
      sectionKey="b1c"
    >
      <div className="sm:col-span-6">
        <Field
          name="b1c.buildingDescription"
          label="Popis stavebních objektů"
          component={RichTextInput}
          aiHint={'Stručný popis stavebních objektů, inženýrských objektů a jejich konstrukcí'}
        />
      </div>
      <div className="sm:col-span-6 mt-5">
        <Field
          component={CheckboxInput}
          name="b1c.hasTechnicalEquipment"
          label="Technická a technologická zařízení"
        />
      </div>
      {formik?.values.b1c?.hasTechnicalEquipment && (
        <div className="sm:col-span-6 pl-7">
          <Field
            name="b1c.technicalEquipment"
            label=""
            component={RichTextInput}
            aiHint={'Popis technických nebo technologických zařízení v odstraňované stavbě'}
          />
        </div>
      )}
    </FormSectionTwoColumns>
  )
}
